module.exports = __webpack_public_path__ + "img/monyBj.ce3908eb.jpg";